var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_root.js
// module id = 47
// module chunks = 0